import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { Polygon } from '../components/workspace/objects/polygon';
import { API } from './api';
import { BrainBankErrorCode } from './error-code';

export interface PredictionResponse {
    classIdentifier: string;
    probability: number;
}

@Injectable()
export class PredictionsProvider extends BaseProvider {
    private predictionPolygons: Polygon[] = [];
    private predictionsLoaded = false;
    public datasetIdentifier: string;
    constructor(private api: API) {
        super();
    }

    // NOTE: The prediction loading methods in this file appear to have been written with the legacy object detection
    // prediction overlay in mind.
    public async loadPredictionsForAsset(assetId: string): Promise<void> {
        let results;
        try {
            this.predictionsLoaded = false;
            results = await this.api.get(`datasets/${this.datasetIdentifier}/infer/${assetId}`);
        } catch (err) {
            if (err.error && err.error.code == BrainBankErrorCode.BrainNotFound) {
                console.log('No brain found for dataset.  Skipping predictions');
                return;
            }
        }

        if (results && results.message.length > 0) {
            this.predictionPolygons = results.message;
            this.predictionsLoaded = true;
        }
    }

    public getPredictions(): Polygon[] {
        return this.predictionPolygons;
    }

    public isLoaded(): boolean {
        return this.predictionsLoaded;
    }
}



// WEBPACK FOOTER //
// ./src/providers/predictions.ts